/* eslint-disable @next/next/no-img-element */
"use client";

import React, { useState, useRef, useEffect } from "react";
import ManabakhBrandIcon from "@/helpers/svg/manabakhBrandIcon.svg";
import ManabakhBrandName from "@/helpers/svg/manabakhBrandName.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ROUTES } from "@/routes/appRoutes";
import UpGo from "@/helpers/svg/upGo.svg";
import { FaAppStoreIos, FaAndroid } from "react-icons/fa";
import { IoLogoPwa } from "react-icons/io5";
import { PiTelevisionSimpleFill } from "react-icons/pi";
import { AiFillAndroid } from "react-icons/ai";
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from "@nextui-org/react";
import BottomArrowIcon from "@/helpers/svg/BottomArrowIcon.svg";
import DownloadApps from "@/helpers/svg/downloadApps.svg";
import Link from "next/link";
import FooterShowMore from "@/helpers/svg/footerShowMore.svg";
import FooterLogoTablet from "@/helpers/svg/footerLogoTablet.svg";
import FooterInstagram from "@/helpers/svg/footerInstagram.svg";
import FooterTelegram from "@/helpers/svg/footerTelegram.svg";
import FooterWhatsapp from "@/helpers/svg/footerWhatsapp.svg";
import FooterBale from "@/helpers/svg/footerBale.svg";
import classNames from "classnames";
import { useRouter } from "next/navigation";


const Footer = () => {
  const [expanded, setExpanded] = useState(false);
  const desktop = useMediaQuery("(min-width:1024px)");
  const [activeSection, setActiveSection] = useState("APP");
  const endRef = useRef();
  const router = useRouter();

  const desktopToggleFooter = () => {
    if (desktop) {
      setExpanded(!expanded);
    }
  };

  const renderMobileActiveSection = () => {
    return (
      <div className="relative h-[70px] max-w-screen">
        <div
          className={classNames(
            "overflow-x-auto w-full flex items-center h-full transition-opacity px-3",
            activeSection === "APP" ? "opacity-1" : "opacity-0"
          )}
        >
          <div className="min-w-fit flex gap-3">
            <Button
              variant="bordered"
              className="text-white border-white"
              color="default"
              endContent={<FaAppStoreIos />}
              key="ios"
              size="md"
            >
              <Link href="/apps">iOS</Link>
            </Button>
            <Button
              variant="bordered"
              className="text-white border-white"
              color="default"
              startContent={<AiFillAndroid />}
              key="android"
              size="md"
            >
              {" "}
              <Link href="/apps">اندروید</Link>
            </Button>
            <Button
              className="text-white border-white"
              variant="bordered"
              color="default"
              startContent={<IoLogoPwa />}
              key="PWA"
              size="md"
            >
              {" "}
              <Link href="/apps">PWA</Link>
            </Button>
            <Button
              variant="bordered"
              className="text-white border-white"
              color="default"
              startContent={<FaAndroid />}
              key="androidTV"
              size="md"
            >
              {" "}
              <Link href="/apps">تلوزیون اندرویدی</Link>
            </Button>
            <Button
              variant="bordered"
              className="text-white border-white"
              color="default"
              startContent={<PiTelevisionSimpleFill />}
              key="webTV"
              size="md"
            >
              {" "}
              <Link href="/apps">تلوزیون هوشمند</Link>
            </Button>
          </div>
        </div>
        <div
          className={classNames(
            "absolute top-0 left-0 right-0 bottom-0 transition-opacity ease-linear duration-200 flex gap-3 w-fit text-white items-center px-3",
            activeSection === "SOCIAL" ? "opacity-1" : "opacity-0"
          )}
          style={{
            opacity: activeSection === "SOCIAL" ? 1 : 0,
          }}
        >
          <Button
            variant="bordered"
            color="default"
            className="text-white border-white"
            startContent={<FooterInstagram />}
            key="instagram"
            size="md"
            href="https://instagram.com/iranmanabakh?igshid=YzAwZjE1ZTI0Zg"
            target="_blank"
          >
            اینستاگرام
          </Button>
          <Button
            variant="bordered"
            className="text-white border-white"
            color="default"
            startContent={<FooterTelegram />}
            key="telegram"
            size="md"
            href="https://t.me/manabakhiran"
            target="_blank"
          >
            تلگرام
          </Button>
          <Button
            variant="bordered"
            className="text-white border-white"
            color="default"
            startContent={<FooterWhatsapp />}
            key="telegram"
            size="md"
            href="#"
            target="_blank"
          >
            واتساپ
          </Button>
          <Button
            variant="bordered"
            className="text-white border-white"
            color="default"
            startContent={<FooterBale />}
            key="bale"
            size="md"
            href="https://web.bale.ai/ble.ir/join/3aXMNsgD3h"
            target="_blank"
          >
            بله
          </Button>
        </div>
        <div
          className={classNames(
            "absolute top-0 left-0 right-0 bottom-0 transition-opacity ease-linear duration-200 flex gap-3 w-fit text-white  items-center px-3",
            activeSection === "PAGES" ? "opacity-1" : "opacity-0"
          )}
        >
          <div
            className="min-w-fit border-2 py-1 px-2 rounded-xl"
            key="/about-us"
          >
            <Link href={ROUTES.about_us} className="text-xs">
              درباره ما
            </Link>
          </div>
          <div className="min-w-fit border-2 py-1 px-2 rounded-xl" key="/">
            <Link href={ROUTES.privacy_policy} className="text-xs">
              قوانین و مقررات
            </Link>
          </div>
          <div className="min-w-fit border-2 py-1 px-2 rounded-xl" key="ads">
            <Link href={ROUTES.ads} className="text-xs">
              آگهی در منه‌باخ
            </Link>
          </div>
          <div
            className="min-w-fit border-2 py-1 px-2 rounded-xl"
            key="cooperation"
          >
            <Link href={ROUTES.cooperation} className="text-xs">
              همکاری با ما
            </Link>
          </div>
          <div
            className="min-w-fit border-2 py-1 px-2 rounded-xl"
            key="faq"
          >
            <Link href={ROUTES.faq} className="text-xs">
              سوالات متداول
            </Link>
          </div>
          <div
            className="min-w-fit border-2 py-1 px-2 rounded-xl"
            key="chat"
          >
            <Link href={ROUTES.profile.chat} className="text-xs">
              پشتیبانی آنلاین
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const changeActiveSection = (newSection) => {
    setActiveSection("");
    setTimeout(() => setActiveSection(newSection), 250);
  };

  const getFooterHeader = () => {
    if (desktop) {
      return (
        <div className="flex justify-between items-center px-4">
          <div className="flex justify-between items-center">
            <div
              style={{
                transition: "transform ease .3s",
                transform: expanded ? "rotate(180deg)" : "rotate(0)",
              }}
            >
              <UpGo onClick={() => setExpanded(!expanded)} />
            </div>
            <Link href={ROUTES.contact_us}>
              <div>
                <Button className="text-primary-white" variant="light">
                  تماس با ما
                </Button>
              </div>
            </Link>
            <Link href={ROUTES.profile.chat}>
              <div>
                <Button className="text-primary-white" variant="light">
                  پشتیبانی آنلاین
                </Button>
              </div>
            </Link>
            <div>
              <Link href={ROUTES.about_us}>
                <Button className="text-primary-white" variant="light">
                  درباره ما
                </Button>
              </Link>
            </div>
            <div>
              <Link href={ROUTES.faq}>
                <Button className="text-primary-white" variant="light">
                  سوالات متداول
                </Button>
              </Link>
            </div>
            {!expanded ? (
              <Dropdown
                onClick={(e) => e.stopPropagation()}
                backdrop="blur"
                className="border-none bg-secondary"
              >
                <DropdownTrigger>
                  <Button
                    variant="light"
                    className="text-primary-white"
                    endContent={<BottomArrowIcon />}
                  >
                    شبکه های اجتماعی
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  className="bg-secondary text-primary-white border-none"
                  aria-label="Static Actions"
                >
                  <DropdownItem
                    endContent={<FooterInstagram />}
                    key="instagram"
                    href="https://instagram.com/iranmanabakh?igshid=YzAwZjE1ZTI0Zg"
                    target="_blank"
                  >
                    اینستاگرام
                  </DropdownItem>
                  <DropdownItem
                    endContent={<FooterTelegram />}
                    key="telegram"
                    href="https://t.me/manabakhiran"
                    target="_blank"
                  >
                    تلگرام
                  </DropdownItem>
                  <DropdownItem endContent={<FooterWhatsapp />} key="whatsapp">
                    واتس آپ
                  </DropdownItem>
                  <DropdownItem
                    endContent={<FooterBale />}
                    key="bale"
                    href="https://web.bale.ai/ble.ir/join/3aXMNsgD3h"
                    target="_blank"
                  >
                    بله
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            ) : (
              <Link href={ROUTES.privacy_policy}>
                <Button className="text-primary-white" variant="light">
                  قوانین و مقررات
                </Button>
              </Link>
            )}
            {!expanded ? (
              <Dropdown
                onClick={(e) => e.stopPropagation()}
                backdrop="blur"
                className="border-none bg-secondary"
              >
                <DropdownTrigger>
                  <Button
                    variant="light"
                    className="text-primary-white"
                    endContent={<BottomArrowIcon />}
                  >
                    سایر صفحات
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  className="bg-secondary text-primary-white border-none"
                  aria-label="Static Actions"
                >
                  <DropdownItem key="/">
                    <Link href={ROUTES.privacy_policy}>قوانین و مقررات</Link>
                  </DropdownItem>
                  <DropdownItem key="ads">
                    <Link href={ROUTES.ads}>آگهی در منه‌باخ</Link>
                  </DropdownItem>
                  <DropdownItem key="cooperation">
                    <Link href={ROUTES.cooperation}>همکاری با ما</Link>
                  </DropdownItem>
                  <DropdownItem key="faq">
                    <Link href={ROUTES.faq}>سوالات متداول</Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            ) : (
              <Link href={ROUTES.ads}>
                <Button className="text-primary-white" variant="light">
                  آگهی در منه باخ
                </Button>
              </Link>
            )}
            {expanded && (
              <Link href={ROUTES.cooperation}>
                <Button className="text-primary-white" variant="light">
                  همکاری با ما
                </Button>
              </Link>
            )}
            <Link href={ROUTES.subscription}>
              <Button className="text-primary-white" variant="light">
                خرید اشتراک
              </Button>
            </Link>
          </div>
          <div className="flex justify-end items-center">
            <Dropdown
              onClick={(e) => e.stopPropagation()}
              backdrop="blur"
              className="border-none bg-secondary"
            >
              <DropdownTrigger>
                <Button
                  variant="light"
                  className="text-primary-white"
                  startContent={<DownloadApps />}
                  endContent={<BottomArrowIcon />}
                >
                  اپلیکیشن‌های منه‌باخ
                </Button>
              </DropdownTrigger>
              <DropdownMenu
                className="bg-secondary text-primary-white border-none"
                aria-label="Static Actions"
              >
                <DropdownItem endContent={<FaAppStoreIos />} key="ios" onClick={() => router.push("/apps")}>
                  <Link href="/apps">iOS</Link>
                </DropdownItem>
                <DropdownItem endContent={<AiFillAndroid />} key="android" onClick={() => router.push("/apps")}>
                  <Link href="/apps">اندروید</Link>
                </DropdownItem>
                <DropdownItem endContent={<IoLogoPwa />} key="PWA" onClick={() => router.push("/apps")}>
                  <Link href="/apps">PWA</Link>
                </DropdownItem>
                <DropdownItem endContent={<FaAndroid />} key="androidTV" onClick={() => router.push("/apps")}>
                  <Link href="/apps">تلوزیون اندرویدی</Link>
                </DropdownItem>
                <DropdownItem
                  endContent={<PiTelevisionSimpleFill />}
                  key="webTV"
                >
                  <Link href="/apps">تلوزیون هوشمند</Link>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="flex justify-between items-start pt-4 w-screen px-4">
            <div className="flex flex-col justify-between items-start">
              <div className="flex justify-between items-center">
                <Link href="/apps" className="ml-4 md:ml-8">
                  <span
                    className={classNames(
                      "text-[12px] font-bold sm:text-sm md:text-base",
                      "text-[#BFBFBF]"
                    )}
                  >
                    اپلیکیشن‌های منه‌باخ
                  </span>
                </Link>
                <div
                  className="ml-4 md:ml-8"
                  onClick={() => {
                    changeActiveSection("SOCIAL");
                    setExpanded(true);
                  }}
                >
                  <span
                    className={classNames(
                      "text-[10px] xs:text-xs sm:text-sm md:text-base",
                      activeSection === "SOCIAL" ? "text-[#971e1e]" : " "
                    )}
                  >
                    شبکه‌های اجتماعی
                  </span>
                </div>
                <div
                  onClick={() => {
                    changeActiveSection("PAGES");
                    setExpanded(true);
                  }}
                >
                  <span
                    className={classNames(
                      "text-[10px] xs:text-xs sm:text-sm md:text-base",
                      activeSection === "PAGES"
                        ? "text-[#971e1e]"
                        : "text-[#BFBFBF] "
                    )}
                  >
                    صفحات
                  </span>
                </div>
                <Link className="mr-3" href={ROUTES.subscription}>
                  <span
                    className={classNames(
                      "text-[10px] xs:text-xs sm:text-sm md:text-base",
                      "text-[#BFBFBF] "
                    )}
                  >
                    خرید اشتراک
                  </span>
                </Link>
              </div>
            </div>
            <div className="relative w-[4px]">
              <FooterShowMore onClick={() => setExpanded(!expanded)} />
            </div>
          </div>
          {expanded && (
            <div className="w-screen">{renderMobileActiveSection()}</div>
          )}
        </>
      );
    }
  };

  useEffect(() => {
    if (expanded === true) {
      setTimeout(
        () =>
          endRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          }),
        200
      );
    }
  }, [expanded]);

  return (
    <footer className="w-screen relative overflow-hidden">
      <section
        className="bg-[#020202] text-center flex items-center flex-col lg:pt-4"
        onClick={desktopToggleFooter}
        style={{
          backgroundColor: "$gray200",
          borderTop: "1px solid $gray300",
          minHeight: 60,
          height: expanded ? (desktop ? 220 : 300) : 60,
          transition: "height 0.2s ease-in-out",
          zIndex: 1000,
        }}
      >
        <div className="w-full">{getFooterHeader()}</div>
        <div className="relative p-4 w-full md:container mx-auto">
          <div className="flex justify-between items-center">
            <div className="flex justify-between items-center">
              <div className="hidden lg:flex">
                <div className="ml-2">
                  <ManabakhBrandName />
                </div>
                <ManabakhBrandIcon />
              </div>
              <div className="flex lg:hidden justify-center items-center pt-4">
                <FooterLogoTablet />
              </div>
            </div>
            <div className="flex items-center gap-3 mt-5">
              <a
                target="_blank"
                referrerPolicy="origin"
                href="https://satra.ir"
                className="relative w-[35px] md:w-[45px] lg:w-[55px] aspect-square"
                aria-label="ساترا – سازمان تنظیم مقررات رسانه‌های صوت و تصویر فراگیر در فضای مجازی"
              >
                <img
                  src="/satra.png"
                  loading="lazy"
                  alt="ساترا – سازمان تنظیم مقررات رسانه‌های صوت و تصویر فراگیر در فضای مجازی"
                />
              </a>
              <a
                target="_blank"
                referrerPolicy="origin"
                href="https://trustseal.enamad.ir/?id=368944&code=LyWVcdKJbwJkAYS0LJI5"
                aria-label="نماد اعتماد الکترونیک"
              >
                <img
                  referrerPolicy="origin"
                  src={
                    process.env.NODE_ENV === "development"
                      ? "/enamad.png"
                      : "https://Trustseal.eNamad.ir/logo.aspx?id=368944&code=LyWVcdKJbwJkAYS0LJI5"
                  }
                  className="w-[35px] md:w-[45px] lg:w-[55px] "
                  loading="lazy"
                  alt="نماد اعتماد الکترونیک"
                />
              </a>
              <a
                target="_blank"
                referrerPolicy="origin"
                href="https://sapra.ir"
                aria-label="ساپرا (سامانه پایش مردمی)"
              >
                <img
                  referrerPolicy="origin"
                  loading="lazy"
                  src={"/sapra.png"}
                  className="w-[35px] md:w-[45px] lg:w-[55px] "
                  alt="ساپرا (سامانه پایش مردمی)"
                />
              </a>
            </div>
          </div>
          <p className="text-primary-white text-[10px] md:text-sm lg:text-base my-5 text-center">
            تمامی حقوق مادی و معنوی این وب سایت برای موسسه فرهنگی و هنری همراه
            هنر آریا محفوظ می باشد.
          </p>
          <p ref={endRef} />
        </div>
      </section>
    </footer>
  );
};

export default Footer;
